<template>
    <transition name="fade-in" @enter="enter">
        <div :class="$style['popup']" v-if="isOpen" ref="popup" :style="popupStyle">
            <div :class="$style['popup__overlay']" @click="close"></div>
            <div :class="$style['popup__container']">
                <div :class="$style['popup__wrapper']">
                    <div :class="[$style['popup__inner'], {[$style['popup__inner_theme_success']]: isSuccess}, {[$style['popup__inner_theme_error']]: isError}]">
                        <div :class="$style['popup__close']" @click="close">
                            <svg width="12"
                                 height="12"
                                 viewBox="0 0 12 12"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 5.29413L0.705868 0L0 0.705868L5.29413 6L0 11.2941L0.705868 12L6 6.70587L11.2941 12L12 11.2941L6.70587 6L12 0.705868L11.2941 0L6 5.29413Z"/>
                            </svg>
                        </div>
                        <div :class="$style['popup__inner-wrapper']">
                            <div :class="$style['popup__content']">
                                <slot></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import Observer from '../../../../src/common/scripts/observer';
    import Utils from '../../helpers/Utils';

    const observer = new Observer();

    export default {
        props: ['isSuccess', 'isError'],

        data: () => ({
            isOpen: false,
            popupStyle: {},
            zIndexClassPopup: 'is-mortgage-popup-open'
        }),

        methods: {
            enter() {
                this.popupStyle = {backdropFilter: 'blur(7px)'}
            },

            open() {
                this.isOpen = true;
            },

            close() {
                this.isOpen = false;
                this.popupStyle = {};
                this.$emit('popupClose');
            },

            _subscribes() {
                observer.subscribe('mortgage:popupOpenFromOutside', () => {
                    this.isOpen = true;
                });
            }
        },

        watch: {
            isOpen(val) {
                if (val) {
                    setTimeout(() => {
                        Utils.bodyFixed(this.$refs.popup);
                    }, 0);
                } else {
                    setTimeout(() => {
                        Utils.bodyStatic();
                    }, 300);
                }
            }
        },

        mounted() {
            this._subscribes();
        }
    }
</script>

<style lang="scss" module>
    @import "./Popup";
</style>

<style lang="scss">
    .fade-in-enter-active,
    .fade-in-leave-active {
        @include transition(opacity, top, backdrop-filter);
        backdrop-filter: blur(7px);
    }

    .fade-in-enter, .fade-in-leave-to {
        opacity: 0;
        backdrop-filter: blur(0px);
    }
</style>
